import Navbar from '../home/components/Navbar';
import Integrations from '../home/components/Integrations';

export default function IntegrationsPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Integrations />
    </div>
  );
}
